import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "How does the 3-day free trial work?",
    a: "You get full access to the AI receptionist live on your actual business lines for 3 days. If you don't see immediate value, cancel before the trial ends and you won't be billed the monthly fee."
  },
  {
    q: "What does the $999 setup fee cover?",
    a: "Our engineers handle everything: AI voice tuning, custom knowledge base ingestion from your website/docs, CRM & calendar integration, and call routing logic. It's a completely done-for-you white-glove setup."
  },
  {
    q: "Does the AI sound like a robot?",
    a: "No. We use ultra-low latency conversational AI with human-like intonation, pausing, and breathing. Most callers do not realize they are speaking to an AI."
  },
  {
    q: "How do I forward my calls to AutoReception?",
    a: "We provide you with a dedicated forwarding number. You simply set your existing business phone to forward calls to this number after a certain amount of rings, or immediately for after-hours."
  },
  {
    q: "Are there call volume limits?",
    a: "The Core plan covers typical local business volume (up to 1,000 AI minutes per month). High-volume custom plans are available upon request."
  }
];

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section id="faq" className="py-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Frequently Asked Questions</h2>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <div key={idx} className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden">
            <button 
              className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
              onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            >
              <span className="font-semibold text-white text-lg">{faq.q}</span>
              <SafeIcon name={openIdx === idx ? "ChevronUp" : "ChevronDown"} className="text-slate-400 text-xl" />
            </button>
            {openIdx === idx && (
              <div className="px-6 pb-5 text-slate-400">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;